(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-fbp-product-favorite]';
  var BUTTON_SELECTOR = '[data-fbp-product-favorite-button]';
  var LABEL_SELECTOR = '[data-fbp-product-favorite-label]';
  var HINT_SELECTOR = '[data-fbp-product-favorite-hint]';
  var PROFILE_SELECTOR = '[data-fbp-product-favorite-profile]';
  var PROFILE_TITLE_SELECTOR = '[data-fbp-product-favorite-profile-title]';
  var PROFILE_TEXT_SELECTOR = '[data-fbp-product-favorite-profile-text]';
  var PROFILE_MESSAGE_SELECTOR = '[data-fbp-product-favorite-profile-message]';
  var PROFILE_DISMISS_SELECTOR = '[data-fbp-product-favorite-profile-dismiss]';
  var DISMISS_PREFIX = 'fbp:customerProfiles:v1:profilePromptDismissed:';
  var FAVORITE_MEMORY_KEY = 'fbp:customerProfiles:v1:favoriteMemory';
  var FAVORITE_MEMORY_LIMIT = 96;
  var browserStorageAvailable = false;
  try {
    var probeKey = FAVORITE_MEMORY_KEY + ':probe';
    window.localStorage.setItem(probeKey, '1');
    browserStorageAvailable = window.localStorage.getItem(probeKey) === '1';
    window.localStorage.removeItem(probeKey);
  } catch (error) {}


  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function text(node, value) {
    if (node) node.textContent = value;
  }

  function getProduct(root) {
    return {
      id: root.getAttribute('data-product-id') || '',
      handle: root.getAttribute('data-product-handle') || '',
      title: root.getAttribute('data-product-title') || '',
      url: root.getAttribute('data-product-url') || '',
      featuredImageUrl: root.getAttribute('data-product-image') || '',
      thumbnailImageUrl: root.getAttribute('data-product-thumb') || '',
      imageAlt: root.getAttribute('data-product-image-alt') || '',
      priceCents: root.getAttribute('data-product-price-cents') || '',
      compareAtPriceCents: root.getAttribute('data-product-compare-at-price-cents') || '',
      currency: root.getAttribute('data-product-currency') || '',
      artist: root.getAttribute('data-product-artist') || '',
      productType: root.getAttribute('data-product-type') || '',
      vendor: root.getAttribute('data-product-vendor') || ''
    };
  }

  function storageKey(product) {
    return DISMISS_PREFIX + (product.handle || product.id || 'unknown');
  }

  function stored(key) {
    try {
      return window.localStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  }

  function store(key, value) {
    try {
      if (value) {
        window.localStorage.setItem(key, '1');
      } else {
        window.localStorage.removeItem(key);
      }
    } catch (error) {}
  }

  function cleanMemoryText(value, limit) {
    return String(value || '').trim().slice(0, limit || 500);
  }

  function favoriteMemoryNow() {
    return new Date().toISOString();
  }

  function favoriteMemoryTimestamp(item) {
    var value = item && (item.lastSeenAt || item.favoritedAt);
    var parsed = Date.parse(value || '');
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function normalizeMemoryItem(item) {
    var handle = cleanMemoryText(item && (item.handle || item.productHandle || item.product_handle), 160);
    if (!handle) return null;
    return {
      handle: handle,
      id: cleanMemoryText(item.id || item.productId || item.product_id, 80),
      title: cleanMemoryText(item.title || item.productTitle || item.product_title || handle.replace(/-/g, ' '), 240),
      url: cleanMemoryText(item.url || item.productUrl || item.product_url || ('/products/' + handle), 500),
      imageUrl: cleanMemoryText(item.imageUrl || item.featuredImageUrl || item.featured_image_url || item.image || '', 700),
      thumbnailImageUrl: cleanMemoryText(item.thumbnailImageUrl || item.thumbUrl || item.thumbnail_image_url || item.thumbnail || item.imageUrl || '', 700),
      imageAlt: cleanMemoryText(item.imageAlt || item.alt || item.title || '', 240),
      priceCents: cleanMemoryText(item.priceCents || item.price_cents || item.price || '', 40),
      compareAtPriceCents: cleanMemoryText(item.compareAtPriceCents || item.compare_at_price_cents || item.compareAtPrice || '', 40),
      currency: cleanMemoryText(item.currency || 'USD', 12),
      artist: cleanMemoryText(item.artist || '', 160),
      productType: cleanMemoryText(item.productType || item.product_type || item.type || '', 160),
      vendor: cleanMemoryText(item.vendor || '', 160),
      favoritedAt: cleanMemoryText(item.favoritedAt || item.firstFavoritedAt || item.first_favorited_at || favoriteMemoryNow(), 40),
      lastSeenAt: cleanMemoryText(item.lastSeenAt || item.last_changed_at || item.favoritedAt || favoriteMemoryNow(), 40),
      source: cleanMemoryText(item.source || 'customer_profiles_v1', 80)
    };
  }

  function readFavoriteMemory() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(FAVORITE_MEMORY_KEY) || '{"items":[]}');
      var sourceItems = Array.isArray(parsed) ? parsed : parsed.items;
      if (!Array.isArray(sourceItems)) return [];
      return sourceItems.map(normalizeMemoryItem).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function writeFavoriteMemory(items) {
    try {
      var unique = [];
      var seen = {};
      items.forEach(function (item) {
        var normalized = normalizeMemoryItem(item);
        if (!normalized || seen[normalized.handle]) return;
        seen[normalized.handle] = true;
        unique.push(normalized);
      });
      unique.sort(function (a, b) {
        return favoriteMemoryTimestamp(b) - favoriteMemoryTimestamp(a);
      });
      var payload = {
        version: 1,
        updatedAt: favoriteMemoryNow(),
        items: unique.slice(0, FAVORITE_MEMORY_LIMIT)
      };
      window.localStorage.setItem(FAVORITE_MEMORY_KEY, JSON.stringify(payload));
      document.dispatchEvent(new CustomEvent('fbp:favorite-memory:changed', {
        bubbles: true,
        detail: { count: payload.items.length }
      }));
      return payload.items;
    } catch (error) {
      return items || [];
    }
  }

  function rememberFavoriteProduct(product) {
    if (!product || !product.handle) return readFavoriteMemory();
    var now = favoriteMemoryNow();
    var current = readFavoriteMemory();
    var existing = current.find(function (item) {
      return item.handle === product.handle;
    });
    var nextItem = normalizeMemoryItem(Object.assign({}, existing || {}, {
      handle: product.handle,
      id: product.id,
      title: product.title,
      url: product.url || ('/products/' + product.handle),
      imageUrl: product.featuredImageUrl,
      thumbnailImageUrl: product.thumbnailImageUrl || product.featuredImageUrl,
      imageAlt: product.imageAlt || product.title,
      priceCents: product.priceCents,
      compareAtPriceCents: product.compareAtPriceCents,
      currency: product.currency || 'USD',
      artist: product.artist,
      productType: product.productType,
      vendor: product.vendor,
      favoritedAt: existing && existing.favoritedAt ? existing.favoritedAt : now,
      lastSeenAt: now,
      source: 'customer_profiles_v1'
    }));
    return writeFavoriteMemory([nextItem].concat(current.filter(function (item) {
      return item.handle !== product.handle;
    })));
  }

  function forgetFavoriteProduct(productOrHandle) {
    var handle = cleanMemoryText(typeof productOrHandle === 'string' ? productOrHandle : productOrHandle && productOrHandle.handle, 160);
    if (!handle) return readFavoriteMemory();
    return writeFavoriteMemory(readFavoriteMemory().filter(function (item) {
      return item.handle !== handle;
    }));
  }

  function clearFavoriteMemory() {
    return writeFavoriteMemory([]);
  }

  function syncFavoriteMemory(product, state) {
    var visualState = favoriteVisualState(state || {});
    if (state && state.active && !state.error && !state.unavailable && visualState !== 'never_favorited') {
      rememberFavoriteProduct(product);
    }
  }

  window.FBPFavoriteMemory = Object.assign(window.FBPFavoriteMemory || {}, {
    key: FAVORITE_MEMORY_KEY,
    list: readFavoriteMemory,
    remember: rememberFavoriteProduct,
    remove: forgetFavoriteProduct,
    clear: clearFavoriteMemory
  });

  function waitForBridge(callback, attempts) {
    var bridge = window.FBPProfilesBridge;
    if (bridge && typeof bridge.setFavorite === 'function' && bridge.isEnabled && bridge.isEnabled()) {
      callback(bridge);
      return;
    }

    if ((attempts || 0) >= 40) {
      callback(null);
      return;
    }

    window.setTimeout(function () {
      waitForBridge(callback, (attempts || 0) + 1);
    }, 100);
  }

  function profileFromResult(result) {
    var profile = result && result.profile ? result.profile : {};
    var subscription = profile.emailSubscription || {};
    return {
      loaded: Boolean(result && result.ok),
      subscribed: Boolean(subscription.active),
      maskedEmail: subscription.maskedEmail || '',
      customerLinked: Boolean(profile.hasCustomerAccount),
      favoriteCount: Number(profile.activeFavoriteCount || 0) || 0
    };
  }

  function setMessage(root, message, tone) {
    var messageNode = root.querySelector(PROFILE_MESSAGE_SELECTOR);
    if (!messageNode) return;
    messageNode.classList.toggle('is-success', tone === 'success');
    messageNode.classList.toggle('is-error', tone === 'error');
    text(messageNode, message || '');
  }

  // Winner email delivery is disabled. A vote confirmation must not imply a subscription
  // or offer a signup for mail that cannot currently be delivered.
  function applyProfilePanel(root, state) {
    var panel = root.querySelector(PROFILE_SELECTOR);
    if (!panel) return;
    var profile = state.profile || {};
    var visible = favoriteVisualState(state) === 'counted_this_week' && state.active &&
      !state.loading && !state.unavailable && !state.error && !profile.dismissed;
    panel.hidden = !visible;
    if (!visible) return;
    text(root.querySelector(PROFILE_TITLE_SELECTOR), 'Your vote is counted.');
    text(root.querySelector(PROFILE_TEXT_SELECTOR), "See the winner and this week's discount in Design of the Week on our homepage.");
    setMessage(root, profile.customerLinked ? 'Saved to your customer profile.' : '', 'success');
  }

  function applyState(root, state) {
    var button = root.querySelector(BUTTON_SELECTOR);
    var label = root.querySelector(LABEL_SELECTOR);
    var hint = root.querySelector(HINT_SELECTOR);
    var active = Boolean(state.active);
    var loading = Boolean(state.loading);
    var saving = Boolean(state.saving);
    var unavailable = Boolean(state.unavailable);
    var profile = state.profile || {};
    var visualState = favoriteVisualState(state);
    var weeklyCounted = visualState === 'counted_this_week';

    root.classList.toggle('is-active', active);
    root.classList.toggle('is-loading', loading);
    root.classList.toggle('is-saving', saving);
    root.classList.toggle('is-unavailable', unavailable);
    root.classList.toggle('has-error', Boolean(state.error));
    root.classList.toggle('is-never-favorited', visualState === 'never_favorited');
    root.classList.toggle('is-previously-favorited', visualState === 'previously_favorited');
    root.classList.toggle('is-counted-this-week', weeklyCounted);
    root.setAttribute('data-favorite-visual-state', visualState);

    if (button) {
      button.disabled = loading || saving || (weeklyCounted && !state.error && !unavailable);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        weeklyCounted
          ? 'Vote counted for this week'
          : visualState === 'previously_favorited'
            ? 'Vote again this week for your saved design'
            : 'Save this design and vote for the weekly discount'
      );
    }

    if (saving) {
      text(label, 'Saving');
    } else if (loading) {
      text(label, 'Checking vote');
    } else if (state.error || unavailable) {
      text(label, 'Check vote status');
      button.setAttribute('aria-label', 'Check vote status before trying again');
    } else if (weeklyCounted) {
      text(label, 'Voted this week');
    } else if (visualState === 'previously_favorited') {
      text(label, 'Vote again this week');
    } else {
      text(label, 'Save & vote');
    }

    if (state.error) {
      text(hint, 'We could not confirm your vote. Check its status before trying again.');
    } else if (unavailable) {
      text(hint, 'We could not load your vote status. Check again when you are online.');
    } else if (weeklyCounted) {
      text(hint, 'Saved design. Your vote has already counted this week; you can vote again next week.');
    } else if (visualState === 'previously_favorited') {
      text(hint, 'This design is still saved. Vote again to enter it in this week’s race.');
    } else if (active && profile.customerLinked) {
      text(hint, 'Saved to your customer profile.');
    } else if (active && profile.subscribed) {
      text(hint, 'Saved to your favorites.');
    } else if (active) {
      if (state.count && state.count > 1) {
        text(hint, 'Saved. ' + state.count + ' favorites this week.');
      } else {
        text(hint, 'Saved on this browser.');
      }
    } else {
      text(hint, 'Save this design and vote for next week’s 15% discount. One counted vote per design each week. No account needed.');
    }

    var persistence = root.querySelector('[data-fbp-favorite-persistence]');
    text(persistence, profile.customerLinked
      ? 'Linked to your customer profile. The saved list below shows designs remembered by this browser.'
      : browserStorageAvailable
        ? 'Saved designs are remembered in this browser. Clearing browser data can remove this list.'
        : 'Browser storage is blocked. A confirmed vote can count, but this browser cannot keep your saved-design list.');
    applyProfilePanel(root, state);
  }

  function getActiveFromResult(result, fallback) {
    if (!result || !result.ok) return fallback;
    if (typeof result.active === 'boolean') return result.active;
    if (result.favorite && result.favorite.status) return result.favorite.status === 'active';
    return fallback;
  }

  function getCountFromResult(result) {
    if (!result || !result.total) return 0;
    if (result.total.eligible_count != null) return Number(result.total.eligible_count || 0) || 0;
    return Number(result.total.active_count || 0) || 0;
  }

  function getWeeklyVoteEligibleFromResult(result, fallback) {
    if (!result || !result.ok) return fallback;
    if (typeof result.weeklyVoteEligible === 'boolean') return result.weeklyVoteEligible;
    if (result.favorite && typeof result.favorite.voteEligible === 'boolean') return result.favorite.voteEligible;
    if (typeof result.voteEligible === 'boolean') return result.voteEligible;
    if (result.weeklyVoteStatus && result.weeklyVoteStatus.hasVote === true) return false;
    return fallback;
  }

  function getWeeklyVoteAlreadyRecordedFromResult(result, fallback) {
    if (!result || !result.ok) return fallback;
    if (typeof result.weeklyVoteAlreadyRecorded === 'boolean') return result.weeklyVoteAlreadyRecorded;
    if (result.favorite && typeof result.favorite.weeklyVoteAlreadyRecorded === 'boolean') {
      return result.favorite.weeklyVoteAlreadyRecorded;
    }
    if (result.weeklyVoteStatus && result.weeklyVoteStatus.hasVote === true) return true;
    return fallback;
  }

  function getFavoriteVisualStateFromResult(result, active, fallback, options) {
    if (!result || !result.ok) return fallback;
    if (typeof result.favoriteVisualState === 'string') return result.favoriteVisualState;
    if (result.favorite && typeof result.favorite.favoriteVisualState === 'string') return result.favorite.favoriteVisualState;
    if (result.weeklyVoteStatus && result.weeklyVoteStatus.hasVote === true) return 'counted_this_week';
    if (options && options.afterFavoriteWrite && active && (
      typeof result.voteEligible === 'boolean' ||
      typeof result.weeklyVoteEligible === 'boolean' ||
      typeof result.weeklyVoteAlreadyRecorded === 'boolean' ||
      (result.favorite && typeof result.favorite.voteEligible === 'boolean') ||
      (result.favorite && typeof result.favorite.weeklyVoteEligible === 'boolean') ||
      (result.favorite && typeof result.favorite.weeklyVoteAlreadyRecorded === 'boolean')
    )) {
      return 'counted_this_week';
    }
    return active ? 'previously_favorited' : 'never_favorited';
  }

  function favoriteVisualState(state) {
    if (state.favoriteVisualState) return state.favoriteVisualState;
    if (state.weeklyVoteAlreadyRecorded === true) return 'counted_this_week';
    if (state.weeklyVoteStatus && state.weeklyVoteStatus.hasVote === true) return 'counted_this_week';
    return state.active ? 'previously_favorited' : 'never_favorited';
  }

  function syncProfile(root, bridge, state) {
    if (!bridge || typeof bridge.getProfileStatus !== 'function') {
      return Promise.resolve(state);
    }

    return bridge.getProfileStatus().then(function (result) {
      if (!result || !result.ok) return state;
      var nextProfile = Object.assign({}, state.profile || {}, profileFromResult(result));
      state = Object.assign({}, state, { profile: nextProfile });
      applyState(root, state);
      return state;
    });
  }

  function linkCustomerProfile(root, bridge, state, product) {
    var canLink = bridge &&
      typeof bridge.linkCurrentCustomer === 'function' &&
      typeof bridge.isCustomerLoggedIn === 'function' &&
      bridge.isCustomerLoggedIn();

    if (!canLink || !state.active || state.profile.customerLinked || state.profile.customerLinkAttempted) {
      return Promise.resolve(state);
    }

    state.profile.customerLinkAttempted = true;
    return bridge.linkCurrentCustomer({
      source: 'favorite_profile_prompt',
      productHandle: product.handle,
      productTitle: product.title
    }).then(function (result) {
      if (!result || !result.ok) return state;
      state.profile.customerLinked = true;
      state.profile.message = 'Saved to your customer profile.';
      state.profile.messageTone = 'success';
      applyState(root, state);
      return syncProfile(root, bridge, state);
    }).catch(function () {
      return state;
    });
  }

  function bindProfileActions(root, bridge, getState, setState, product) {
    var dismiss = root.querySelector(PROFILE_DISMISS_SELECTOR);
    if (!dismiss) return;
    dismiss.addEventListener('click', function () {
      var state = getState();
      state.profile.dismissed = true;
      state.profile.message = '';
      store(storageKey(product), true);
      setState(state);
    });
  }

  function warehouseOfferSelected(root) {
    return root.classList.contains('fbp-profile-favorite') && document.body.classList.contains('fbp-warehouse-product-active');
  }

  function initFavorite(root, bridge) {
    var button = root.querySelector(BUTTON_SELECTOR);
    var product = getProduct(root);
    var state = {
      active: false,
      loading: true,
      saving: false,
      unavailable: false,
      error: false,
      count: 0,
      weeklyVoteEligible: null,
      weeklyVoteAlreadyRecorded: false,
      favoriteVisualState: 'never_favorited',
      profile: {
        dismissed: stored(storageKey(product)),
        subscribed: false,
        maskedEmail: '',
        customerLinked: false,
        customerLinkAttempted: false,
        submitting: false,
        submitted: false,
        message: '',
        messageTone: ''
      }
    };

    function setState(nextState) {
      state = nextState;
      applyState(root, state);
    }

    function getState() {
      return state;
    }

    if (!button || !product.handle) {
      root.hidden = true;
      return;
    }

    if (!bridge) {
      applyState(root, { loading: false, saving: false, unavailable: true, profile: state.profile });
      text(root.querySelector(LABEL_SELECTOR), 'Reload favorites');
      text(root.querySelector(HINT_SELECTOR), 'Favorites could not start. Reload the page to try again.');
      button.setAttribute('aria-label', 'Reload the page to restore favorites');
      button.addEventListener('click', function () { window.location.reload(); }, { once: true });
      return;
    }

    function syncOfferEligibility() { root.hidden = warehouseOfferSelected(root); }
    document.addEventListener('fbp:warehouse-mode-changed', syncOfferEligibility);
    syncOfferEligibility();
    bindProfileActions(root, bridge, getState, setState, product);
    applyState(root, state);

    function refreshStatus() {
      if (state.loading && !state.initial) return;
      state.initial = false;
      state = Object.assign({}, state, { loading: true, saving: false, error: false });
      applyState(root, state);
      return bridge.getFavoriteStatus(product.handle, { refresh: true }).then(function (result) {
        if (!result || !result.ok) throw new Error('status_unavailable');
        state = Object.assign({}, state, {
          active: getActiveFromResult(result, false), loading: false, saving: false,
          unavailable: false, error: false, count: getCountFromResult(result),
          weeklyVoteEligible: getWeeklyVoteEligibleFromResult(result, null),
          weeklyVoteAlreadyRecorded: getWeeklyVoteAlreadyRecordedFromResult(result, false),
          favoriteVisualState: getFavoriteVisualStateFromResult(result, getActiveFromResult(result, false), 'never_favorited')
        });
        applyState(root, state);
        syncFavoriteMemory(product, state);
        linkCustomerProfile(root, bridge, state, product).then(function (next) {
          state.profile = Object.assign({}, state.profile, next.profile || {});
          applyState(root, state);
        });
      }).catch(function () {
        state = Object.assign({}, state, { loading: false, saving: false, unavailable: true, error: true });
        applyState(root, state);
      });
    }
    state.initial = true;
    refreshStatus();
    if (typeof bridge.getProfileStatus === 'function') bridge.getProfileStatus().then(function (result) {
      if (result && result.ok) {
        state.profile = Object.assign({}, state.profile, profileFromResult(result));
        applyState(root, state);
      }
    }).catch(function () {});

    button.addEventListener('click', function () {
      if (warehouseOfferSelected(root)) { root.hidden = true; return; }
      if (state.loading || state.saving) return;
      if (state.error || state.unavailable) { refreshStatus(); return; }
      if (favoriteVisualState(state) === 'counted_this_week') return;

      var nextActive = true;
      state = Object.assign({}, state, {
        active: nextActive,
        loading: true,
        saving: true,
        unavailable: false,
        error: false,
        count: state.count
      });
      applyState(root, state);

      bridge.setFavorite(product, nextActive).then(function (result) {
        state = Object.assign({}, state, {
          active: getActiveFromResult(result, false),
          loading: false,
          saving: false,
          unavailable: !result || !result.ok,
          error: !result || !result.ok,
          count: getCountFromResult(result),
          weeklyVoteEligible: getWeeklyVoteEligibleFromResult(result, state.weeklyVoteEligible),
          weeklyVoteAlreadyRecorded: getWeeklyVoteAlreadyRecordedFromResult(result, state.weeklyVoteAlreadyRecorded),
          favoriteVisualState: getFavoriteVisualStateFromResult(
            result,
            getActiveFromResult(result, false),
            state.favoriteVisualState,
            { afterFavoriteWrite: nextActive }
          )
        });
        applyState(root, state);
        syncFavoriteMemory(product, state);
        return syncProfile(root, bridge, state)
          .then(function (nextState) {
            state = nextState;
            syncFavoriteMemory(product, state);
            return linkCustomerProfile(root, bridge, state, product);
          })
          .then(setState);
      }).catch(function () {
        state = Object.assign({}, state, {
          active: !nextActive,
          loading: false,
          saving: false,
          unavailable: false,
          error: true,
          count: state.count
        });
        applyState(root, state);
      });
    });
  }

  var favoriteRootObserver = null;

  function initFavoriteRoot(root, bridge) {
    if (!root || root.dataset.fbpProductFavoriteInitialized === '1') return;
    root.dataset.fbpProductFavoriteInitialized = '1';
    if (favoriteRootObserver) favoriteRootObserver.unobserve(root);
    initFavorite(root, bridge);
  }

  function ensureFavoriteRootObserver(bridge) {
    if (favoriteRootObserver || !('IntersectionObserver' in window)) return favoriteRootObserver;
    favoriteRootObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
        initFavoriteRoot(entry.target, bridge);
      });
    }, { rootMargin: '300px 0px' });
    return favoriteRootObserver;
  }

  function queueFavoriteRoot(root, bridge) {
    if (!root || root.dataset.fbpProductFavoriteInitialized === '1') return;
    var observer = ensureFavoriteRootObserver(bridge);
    if (!observer) {
      initFavoriteRoot(root, bridge);
      return;
    }
    if (root.dataset.fbpProductFavoriteObserved === '1') return;
    root.dataset.fbpProductFavoriteObserved = '1';
    observer.observe(root);
  }

  function scanFavoriteRoots(bridge, scope) {
    var roots = Array.prototype.slice.call((scope || document).querySelectorAll(ROOT_SELECTOR));
    roots.forEach(function (root) {
      queueFavoriteRoot(root, bridge);
    });
  }

  function observeFavoriteRoots(bridge) {
    if (!document.body || window.__fbpProductFavoriteObserverBound) return;
    window.__fbpProductFavoriteObserverBound = true;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(ROOT_SELECTOR)) {
            queueFavoriteRoot(node, bridge);
            return;
          }
          if (node.querySelector && node.querySelector(ROOT_SELECTOR)) {
            scanFavoriteRoots(bridge, node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  ready(function () {
    waitForBridge(function (bridge) {
      scanFavoriteRoots(bridge, document);
      observeFavoriteRoots(bridge);
    });
  });
})();
